import Symbol2d from '../2d.js'

export default class UturnArrow extends Symbol2d {

  calculateMinY (dimensions, handles, isLeft, offset = 0) {
    const radius = isLeft ? dimensions.width - dimensions.width * handles[1].coords[0] : dimensions.width * handles[1].coords[0]
    const baseWidth = isLeft ? dimensions.width * handles[0].coords[0] * 2 : (dimensions.width - dimensions.width * handles[0].coords[0]) * 2
    const minY = (Math.max(radius, baseWidth) + offset) / dimensions.height

    return minY
  }

  onDimensionsChange (dimensions, handles) {
    if (dimensions.diff.width && dimensions.height > dimensions.width) {
      // Width is changing, adjust the tip height and width
      this.properties.tipHeight += dimensions.diff.height * this.properties.tipHeight
      this.properties.tipWidth += dimensions.diff.width * this.properties.tipWidth

      if (dimensions.height > dimensions.width) {
        // When the height is greater than the width, we want to scale the properties
        this.properties.radius += dimensions.diff.width * this.properties.radius
      }
    }

    if (dimensions.diff.height && dimensions.height < dimensions.width) {
      // Height is changing and the width is greater than the height
      this.properties.radius += dimensions.diff.height * this.properties.radius
      this.properties.tipWidth += dimensions.diff.height * this.properties.tipWidth
      this.properties.tipHeight += dimensions.diff.height * this.properties.tipHeight
    }

    this.updateHandles(handles, dimensions)
  }

  getComponents (data, dimensions) {
    const handles = this.getHandles(dimensions)

    // Set the tip height and width
    if (!this.properties) {
      // Initial render
      this.properties = this.getProperties(dimensions, handles.map(h => h.coords))
    }

    const paths = this.getPaths(data, dimensions, handles.map(handle => handle.coords))

    return {
      handles,
      flattenedPaths: paths.length > 1 ? this.getFlattenedPaths(data, dimensions) : paths,
      paths
    }
  }

  updateHandles (handles, dimensions) {
    if (this.lockedBase) {
      // The arrow tip head needs to be maintained
      handles[0][0] = this.isLeft ? this.properties.tipWidth / (dimensions.width * 2) : 1 - (this.properties.tipWidth / (dimensions.width * 2))
      handles[0][1] = handles[2][1] - (this.properties.tipHeight / dimensions.height)
    } else {
      // Arrow head tip is locked to the base
      handles[0][0] = this.isLeft ? this.properties.tipWidth / (dimensions.width * 2) : 1 - (this.properties.tipWidth / (dimensions.width * 2))
      handles[0][1] = (dimensions.height - this.properties.tipHeight) / dimensions.height
    }

    // Radius
    handles[1][0] = this.isLeft ? 1 - (this.properties.radius / dimensions.width) : this.properties.radius / dimensions.width
  }

  getProperties (dimensions, handles) {
    const tipBottom = this.lockedBase ? dimensions.height * handles[2][1] : dimensions.height

    return {
      tipHeight: tipBottom - dimensions.height * handles[0][1],
      tipWidth: (this.isLeft ? handles[0][0] : 1 - handles[0][0]) * dimensions.width * 2,
      radius: (this.isLeft ? 1 - handles[1][0] : handles[1][0]) * dimensions.width
    }
  }

  onHandleChange (handle, diff, handles, dimensions) {
    if (handle.idx === 1) {
      // Moving the radius, make sure the new radius doesn't go lower than the arrowhead control.
      const headLength = handles[2].coords[1] - handles[0].coords[1]
      const minY = this.calculateMinY(dimensions, [handles[0], handle], this.isLeft)

      handles[0].coords[1] = Math.max(minY, handles[0].coords[1])

      // Maintain the arrowhead height
      handles[2].coords[1] = Math.min(handles[0].coords[1] + headLength, 1)
    } else if (this.lockedBase && handle.idx === 2) {
      // Moving the tip, but the arrowhead height is maintained, so we need to adjust
      // the first handle to maintain the arrowhead height.
      handles[0].coords[1] += diff[1]
    }

    // reset the properties
    this.properties = this.getProperties(dimensions, handles.map(h => h.coords))
  }

  getHandles (dimensions) {
    const handles = this._getDefaultHandles()
    const arrowWidth = this.isLeft ? dimensions.width * handles[0].coords[0] * 2 : (dimensions.width - dimensions.width * handles[0].coords[0]) * 2

    // Position the third handle based on the arrow direction
    if (this.lockedBase) {
      const tipCenter = this.isLeft ? arrowWidth : (dimensions.width - arrowWidth)
      handles[2].coords[0] = tipCenter / dimensions.width
    } else {
      handles[2].coords[0] =( this.isLeft ? dimensions.width - arrowWidth / 2 : arrowWidth / 2) / dimensions.width
    }

    return [
      handles[0],
      handles[1],
      handles[2]
    ].map(handle => this.enforceConstraints(handle, dimensions, handles))
  }


}
